<template>
  <div class="dialog" id="J_dialog" v-show="showEvaluation" :style="{top: dialogTop + 'px'}">
    <div class="dialog-title">评价反馈</div>
    <div class="dialog-body">
      <div class="dialog-info">
        当前客服：<span style="color: #222">{{ serviceId }}</span> 的服务已经结束，期待您对本次客服的反馈。
        <br>
        我们下次会努力做的更好~
      </div>
      <br>
      <ul class="evaluation-list clearfix" id="feedbackCard">
        <li v-for="option in options">
          <div v-if="option.id == '101'" @click="feelSmile">
            <i class="icon smile-icon"> </i>
            <i class="text">{{ option.text }}</i>
            <i class="icon check-icon"> </i>
          </div>
          <div v-if="option.id == '102'" @click="feelNormal">
            <i class="icon normal-icon"> </i>
            <i class="text">{{ option.text }}</i>
            <i class="icon check-icon"> </i>
          </div>
          <div v-if="option.id == '103'" @click="feelAngry">
            <i  class="icon angry-icon"> </i>
            <i class="text">{{ option.text }}</i>
            <i class="icon check-icon"> </i>
          </div>
        </li>
      </ul>

      <div class="feedback"  v-show="showFeedback">
        <div class="feedback-card">
          <div v-if="feel == 'smile'" class="card-header">
            <h4 class="smile-info">谢谢您的反馈！我们会再接再励！</h4>
          </div>
          <div v-if="feel == 'angry' || feel == 'normal'" class="feedback-card">
            <div class="card-header">
              <h4 class="angry-info">亲，请告诉我您对本次服务不够满意的原因：</h4>
            </div>
            <div class="card-body">
              <ul id="feedback">
                <li v-for="reason in reasons" v-bind:class="activeClass" @click="checkReason" data-id="{{ reason.id }}">
                  {{ reason.text }}
                  <i class="icon check-icon"> </i>
                </li>
                <li v-show="show" id="remarks"><textarea v-model="remark" placeholder="备注, 不超过20字"></textarea></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <!--<span class="btn btn-default" v-bind:class="cancelClass" @click="cancelFeedback">取消</span>-->
      <span class="btn " v-bind:class="submitClass" @click="submitFeedback">提交</span>
    </div>
  </div>
</template>

<script>
  export default{
    props: ['message', 'service'],
    data(){
      return{
        disabledClass: '',
        show: false,
        showFeedback: false,
        showEvaluation: true,
        submitClass: 'disabled',
        cancelClass: '',
        feel: '',
        serviceId: '',
        remark: '',
        dialogTop: '300',
        options: [],
        reasons: [],
        evaluation: []
      }
    },
    ready() {
      this.options = this.message.LEVEL0[0].options;
      this.reasons = [];
      if(this.message.LEVEL0[2] && this.message.LEVEL0[2].options){
       this.reasons = this.message.LEVEL0[2].options;
      }
      this.serviceId = this.service;
      var dom = document.getElementById("J_dialog").parentNode.parentNode;
      this.dialogTop = dom.scrollHeight - 450;
    },
    methods: {
      feelSmile(event) {
        var current = event.currentTarget.parentNode;
        var dom = document.getElementById('feedbackCard').childNodes;
        for(var i = 2; i < 5; i++) {
            dom[i].className = '';
        }
        current.className="active";
        this.showFeedback = true;
        this.feel = "smile";
        this.submitClass = '';
        this.cancelClass = 'disabled';
        this.evaluation = [
          {
            "question": "0",
            "option": [
              {
                "id": "101"
              }
            ]
          }
        ];
      },
      feelNormal(event) {
        var current = event.currentTarget.parentNode;
        var dom = document.getElementById('feedbackCard').childNodes;
        for(var i = 2; i < 5; i++) {
          dom[i].className = '';
        }
        current.className="active";
        this.showFeedback = true;
        this.feel = "normal";
        this.cancelClass = 'disabled';
      },
      feelAngry(event) {
        var current = event.currentTarget.parentNode;
        var dom = document.getElementById('feedbackCard').childNodes;
        for(var i = 2; i < 5; i++) {
          dom[i].className = '';
        }
        current.className="active";
        this.showFeedback = true;
        this.feel = "angry";
        this.cancelClass = 'disabled';
      },
      checkReason(event) {
        var me = this;
        var current = event.currentTarget;
        me.submitClass = '';
        me.activeClass = '';
        var dom = document.getElementById('feedback').childNodes;
        for(var i = 2; i < dom.length; i++) {
          dom[i].className = '';
        }
        current.className = 'active';
        var id = current.attributes['data-id'].value;
        if (id) {
          me.disableClass = "";
        }
        if (me.feel == 'normal') {
          me.evaluation = [
            {
              "question": "0",
              "option": [
                {
                  "id": '102',
                }
              ]
            },
            {
              "question": "10801",
              "option": [
                {
                  "id":id,
                }
              ]
            }
          ];
        } else if (me.feel == "angry") {
          me.evaluation = [
            {
              "question": "0",
              "option": [
                {
                  "id": '103',
                }
              ]
            },
            {
              "question": "10801",
              "option": [
                {
                  "id":id,
                }
              ]
            }
          ];
        }

        if (id == '10904') {
          me.show = true;
          me.evaluation.push({
            "question": "101",
            "text": ''
          });
        }
      },
      submitFeedback() {
        var me = this;
        me.showEvaluation = false;
        if (me.evaluation.length == 3) {
          me.evaluation[2].text = me.remark;
        }
        me.$dispatch('feedback', me.feel, me.evaluation);
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../assets/base.less";

  .dialog {
    z-index: 2000;
    width: 400px;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,.3);
    background: #fff;
    position: absolute;
    left: 560px;

    .dialog-title {
      background: @light;
      border-bottom: 1px solid @border;
      padding-left: 20px;
      font-size: 14px;
      line-height: 36px;
      height: 36px;
      font-weight: bold;
    }

    .dialog-body {
      padding: 20px;
      font-size: 12px;
      color: @gray;
      border-bottom: 1px solid @border;

      ul {
        list-style: none;
      }
    }

    .dialog-footer {
      float: right;
      padding: 10px 20px;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 1000;
    background-color: #000;
    outline: 0;
    opacity: .5;
    filter: alpha(opacity=50);
    color: black;
  }

  .evaluation-list li {
    float: left;
    width: 110px;
    height: 36px;
    margin-left: 10px;
    border: 1px solid @border;
    line-height: 36px;
    cursor: pointer;
    font-size: 14px;
    box-sizing: border-box;

    &:first-child {
      margin-left: 0;
    }
    .icon {
      margin-left: 20px;
      font-size: 24px;
    }

    .smile-icon:before {
      content: '\e61c';
      color: @smile;
    }

    .normal-icon:before {
      content: '\e623';
      color: @normal;

    }

    .angry-icon:before {
      content: '\e618';
      color: @angry;
    }

    .text {
      margin-left: 6px;
      position: absolute;
    }
  }

  .evaluation-list li:hover {
    border: 1px solid @main-color;
  }

  .evaluation-list li.active {
    border: 2px solid @main-color;
    .check-icon {
      position: absolute;
      margin-left: 30px;
    }
    .check-icon:before {
      content: '\e640';
      font-size: 32px;
      color: @main-color;
    }
  }

  .evaluation-list li.disabled {
    pointer-events: none;
    color: @lightGray;
    border: 1px solid @lighterGray;
    background-color: @lighterGray;
    box-shadow: none;
  }

  .evaluation-list li:active {
    background: rgba(0, 167, 191, 0.2);
  }

  .evaluation-list li.disabled .smile-icon:before, .evaluation-list li.disabled .normal-icon:before, .evaluation-list li.disabled .angry-icon:before {
    color: @lightGray;
  }

  .feedback-card {
    .card-header {
      padding-top: 10px;
      h3 {
        font-size: 14px;
        line-height: 1.5;
        font-weight: normal;
      }

      h4 {
        font-size: 12px;
        line-height: 1.5;
        color: @main-color;
        font-weight: normal;
      }

      .smile-info {
        color: @blue;
      }

      .angry-info {
        color: @red2;
      }
    }
    .card-body {
      font-size: 12px;
      ul {
        list-style: none;

        li {
          margin: 10px 0;
          border: 1px solid @border;
          padding: 10px;
          cursor: pointer;
        }

        li.active {
          border: 2px solid @main-color;
          .icon {
            float: right;
            margin-top: -4px;
            margin-right: -10px;
          }
          .check-icon:before {
            content: '\e640';
            font-size: 32px;
            color: @main-color;
          }
        }

        #remarks {
          padding: 0;
          textarea {
            border: none;
            width: 334px;
            height: 60px;
            padding: 10px;
            outline: none;
          }
        }
      }
    }

    .card-footer {
      padding: 10px;
      .btn-default {
        float: right;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// FeedbackCard.vue?489dd00d